(function() {
  var Controller, DeleteDialog, Storage,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty,
    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  Controller = App.loadClass('core::Angular/Controller');

  DeleteDialog = App.loadClass('core::DeleteDialog');

  Storage = App.loadClass('core::Storage');

  exports.ViewController = (function(superClass) {
    extend(ViewController, superClass);

    function ViewController(state, scope, transitions, data, window1, legacyHandler, modal, currentLayer, loader, downloadHandler, stateParams, q, ngModal, http) {
      var promises;
      this.state = state;
      this.scope = scope;
      this.transitions = transitions;
      this.data = data;
      this.window = window1;
      this.legacyHandler = legacyHandler;
      this.modal = modal;
      this.currentLayer = currentLayer;
      this.loader = loader;
      this.downloadHandler = downloadHandler;
      this.stateParams = stateParams;
      this.q = q;
      this.ngModal = ngModal;
      this.http = http;
      this.layerUpdated = bind(this.layerUpdated, this);
      this.destroyDialog = bind(this.destroyDialog, this);
      this.endBulkDelete = bind(this.endBulkDelete, this);
      this.getCountByLayerType = bind(this.getCountByLayerType, this);
      this.launchBulkDeleteDialog = bind(this.launchBulkDeleteDialog, this);
      this.toggleBulkDeleteLayer = bind(this.toggleBulkDeleteLayer, this);
      this.startBulkDelete = bind(this.startBulkDelete, this);
      this.checkBulkDelete = bind(this.checkBulkDelete, this);
      this.callResizer = bind(this.callResizer, this);
      this.launchRestrictedDeleteDialog = bind(this.launchRestrictedDeleteDialog, this);
      this.deleteLayer = bind(this.deleteLayer, this);
      this.editRxLayer = bind(this.editRxLayer, this);
      this.editManagementZoneLayer = bind(this.editManagementZoneLayer, this);
      this.editLegacyLayer = bind(this.editLegacyLayer, this);
      this.editFormLayer = bind(this.editFormLayer, this);
      this.editLayer = bind(this.editLayer, this);
      this.viewLegacyLayer = bind(this.viewLegacyLayer, this);
      this.viewFormLayer = bind(this.viewFormLayer, this);
      this.isAngularLayer = bind(this.isAngularLayer, this);
      this.irrigationDetails = bind(this.irrigationDetails, this);
      this.handleRowClick = bind(this.handleRowClick, this);
      this.destroyActiveLayer = bind(this.destroyActiveLayer, this);
      this.destroyAllActiveLayers = bind(this.destroyAllActiveLayers, this);
      this.getLayerTitle = bind(this.getLayerTitle, this);
      this.getMapCountByType = bind(this.getMapCountByType, this);
      this.getLayerCountByType = bind(this.getLayerCountByType, this);
      this.sortTableData = bind(this.sortTableData, this);
      this.getTableData = bind(this.getTableData, this);
      this.loadScopeData = bind(this.loadScopeData, this);
      this.update_dropdown_styling = bind(this.update_dropdown_styling, this);
      this.showLoader = bind(this.showLoader, this);
      this.downgradedDialogSaved = bind(this.downgradedDialogSaved, this);
      this.downgradedDialogClosed = bind(this.downgradedDialogClosed, this);
      ViewController.__super__.constructor.call(this, this.scope, this.transitions);
      this.angularLayers = ['cover_crop', 'fertilizer', 'spraying'];
      this.scope.ngModalLauncherOptions = {
        resolve: {},
        ngbModalOptions: {
          size: 'lg',
          windowClass: 'extra-wide-form'
        }
      };
      this.scope.event = 'rendered';
      this.scope.appendToEl = angular.element('#bs2-container');
      this.scope.$on('$destroy', (function(_this) {
        return function() {
          _this.loader.hideAll();
          if (_this.state.is('data.add')) {
            return _this.destroyAllActiveLayers();
          } else {
            App.layer_store.empty();
            _this.legacyHandler.destroyAllSubHandlers();
            return _this.legacyHandler.legend.cleanup();
          }
        };
      })(this));
      this.scope.$watch('all_years', (function(_this) {
        return function() {
          var ref;
          if ((_this.scope.all_years != null) && (_this.scope.selected_options.year != null)) {
            if ((_this.scope.selected_options.year != null) && (ref = _this.scope.selected_options.year, indexOf.call(_this.scope.all_years, ref) < 0)) {
              return _this.scope.selected_options.year = _this.scope.all_years[0];
            }
          }
        };
      })(this));
      this.scope.$on('layer:updated', (function(_this) {
        return function(event, attrs) {
          return _this.layerUpdated(event, attrs);
        };
      })(this));
      this.scope.$on('legacyDialog:closed', (function(_this) {
        return function(event, attrs) {
          return _this.destroyActiveLayer(attrs.layer);
        };
      })(this));
      this.scope.$on('legend:update-rows', (function(_this) {
        return function() {
          _this.scope.legend_rows = _this.legacyHandler.legend.constructRows();
          return _this.scope.$apply();
        };
      })(this));
      this.scope.$on('legend:stack-ready', (function(_this) {
        return function() {
          if (_this.legacyHandler.legend.comparePreviousStackValues(_this.scope.legend_rows)) {
            return _this.legacyHandler.legend.updateLegend();
          } else {
            return _this.scope.legend_rows = _this.legacyHandler.legend.getPreviousStack();
          }
        };
      })(this));
      this.scope.$on('rendered', (function(_this) {
        return function() {
          _this.legacyHandler.legend.updateLegend();
          return _this.scope.$apply();
        };
      })(this));

      /* Deep watch selected_options */
      this.scope.$watch('selected_options', (function(_this) {
        return function() {
          var ref, ref1;
          if (((ref = _this.scope.selected_options) != null ? ref.field : void 0) && ((ref1 = _this.scope.selected_options) != null ? ref1.year : void 0)) {
            _this.legacyHandler.destroyAllSubHandlers();
            _this.getTableData(_this.scope.selected_options.year, _this.scope.selected_options.field.field_id);
            _this.scope.ngModalLauncherOptions.resolve.fieldId = _this.scope.selected_options.field.field_id;
            return _this.scope.ngModalLauncherOptions.resolve.year = _this.scope.selected_options.year;
          }
        };
      })(this), true);
      this.scope.$on('data-view:resized', (function(_this) {
        return function() {
          return _this.loader.hideAll();
        };
      })(this));
      this.scope.$on('app:safelinked', (function(_this) {
        return function() {
          _this.scope.active = false;
          _this.scope.$parent.selected_options.field = null;
          _this.scope.selected_options.field = null;
          _this.loadScopeData(_this.data.getAllYears(), 'all_years');
          _this.loadScopeData(_this.data.getSidebarFields(), 'fields');
          _this.loadScopeData(_this.data.getUserType(), 'is_owner');
          _this.scope.formsData = [];
          return _this.scope.mapsData = [];
        };
      })(this));
      this.scope.selected_options = this.scope.$parent.selected_options;
      this.scope.tableData = null;
      this.scope.formsData = [];
      this.scope.mapsData = [];
      this.scope.bulkDeleteArray = [];
      this.scope.activeLayers = [];
      this.scope.legend_rows = [];
      this.scope.active = true;
      this.scope.view = true;
      this.scope.startEdit = false;
      this.scope.bulkDeleting = false;
      this.scope.useSlider = true;
      this.scope.showDelete = false;
      this.scope.styling_finished = false;
      this.scope.form_table_style = {
        height: 0
      };
      this.scope.map_table_style = {
        height: 0
      };
      this.scope.new_dropdown_style = {
        position: '',
        top: 0,
        left: 0,
        width: 0
      };
      this.scope.getTableData = this.getTableData;
      this.scope.handleRowClick = this.handleRowClick;
      this.scope.editLayer = this.editLayer;
      this.scope.editManagementZoneLayer = this.editManagementZoneLayer;
      this.scope.editRxLayer = this.editRxLayer;
      this.scope.deleteLayer = this.deleteLayer;
      this.scope.startBulkDelete = this.startBulkDelete;
      this.scope.launchBulkDeleteDialog = this.launchBulkDeleteDialog;
      this.scope.endBulkDelete = this.endBulkDelete;
      this.scope.downloadFile = this.downloadHandler.downloadFile;
      this.scope.handleTableHeight = this.handleTableHeight;
      this.scope.update_dropdown_styling = this.update_dropdown_styling;
      this.scope.irrigationDetails = this.irrigationDetails;
      this.scope.isAngularLayer = this.isAngularLayer;
      this.scope.getComponentByLayer = this.getComponentByLayer;
      this.scope.getModalOptionsByLayer = this.getModalOptionsByLayer;
      this.scope.downgradedDialogClosed = this.downgradedDialogClosed;
      this.scope.downgradedDialogSaved = this.downgradedDialogSaved;
      this.scope.getLayerCountByType = this.getLayerCountByType;
      this.scope.getLayerTitle = this.getLayerTitle;
      promises = [this.loadScopeData(this.data.getSidebarFields(), 'fields'), this.loadScopeData(this.data.getUserType(), 'is_owner')];
      this.q.all(promises).then((function(_this) {
        return function() {
          var field, i, len, ref;
          if (_this.stateParams.field) {
            ref = _this.scope.fields;
            for (i = 0, len = ref.length; i < len; i++) {
              field = ref[i];
              if (parseInt(field.field_id) === parseInt(_this.stateParams.field)) {
                _this.scope.selected_options.field = field;
                break;
              }
            }
          }
          if (_this.stateParams.year) {
            return _this.scope.selected_options.year = _this.stateParams.year;
          }
        };
      })(this));
    }

    ViewController.prototype.downgradedDialogClosed = function(result) {
      var i, layer, len, ref, results;
      ref = this.scope.activeLayers;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        layer = ref[i];
        if (this.isAngularLayer(layer)) {
          results.push(this.destroyActiveLayer(layer));
        }
      }
      return results;
    };

    ViewController.prototype.downgradedDialogSaved = function(result) {
      return this.layerUpdated();
    };

    ViewController.prototype.showLoader = function() {
      var msg;
      return msg = this.loader.overSidebar('Loading...');
    };

    ViewController.prototype.update_dropdown_styling = function() {
      this.scope.styling_finished = true;
      return this.scope.$digest();
    };

    ViewController.prototype.loadScopeData = function(promise, key) {
      promise.then((function(_this) {
        return function(response) {
          var ref, ref1;
          if ((response != null ? (ref = response.data) != null ? (ref1 = ref.status) != null ? ref1.type : void 0 : void 0 : void 0) === 'success') {
            return _this.scope[key] = response.data.data;
          }
        };
      })(this));
      return promise;
    };

    ViewController.prototype.getTableData = function(year, field_id) {
      if (!field_id) {
        return;
      }
      this.scope.showDelete = false;
      this.scope.tableData = null;
      this.showLoader();
      if ((field_id != null) && (year != null)) {
        this.data.loadFieldBoundary(field_id);
        return this.loadScopeData(this.data.getTableData(year, field_id), 'tableData').then((function(_this) {
          return function(response) {
            return _this.sortTableData();
          };
        })(this));
      }
    };

    ViewController.prototype.sortTableData = function() {
      var i, layer, len, ref, ref1;
      this.scope.formsData = [];
      this.scope.mapsData = [];
      ref = this.scope.tableData;
      for (i = 0, len = ref.length; i < len; i++) {
        layer = ref[i];
        if (((ref1 = layer.layer_type) === 'planting_rx' || ref1 === 'shapefile') || layer.is_map) {
          layer.is_map = true;
          this.scope.mapsData.push(layer);
        } else {
          layer.is_map = false;
          this.scope.formsData.push(layer);
        }
      }
      this.checkBulkDelete();
      return this.callResizer();
    };

    ViewController.prototype.getLayerCountByType = function(layerType) {
      return this.scope.formsData.filter((function(_this) {
        return function(layer) {
          return layer.layer_type === layerType;
        };
      })(this)).length;
    };

    ViewController.prototype.getMapCountByType = function(activeLayer) {
      return this.scope.mapsData.filter((function(_this) {
        return function(layer) {
          if (layer.category_name) {
            return layer.category_name === activeLayer.category_name;
          }
          return layer.layer_type === activeLayer.layer_type;
        };
      })(this)).length;
    };

    ViewController.prototype.getLayerTitle = function(layer, isMapLayer) {
      if (isMapLayer == null) {
        isMapLayer = true;
      }
      if (isMapLayer) {
        if (this.getMapCountByType(layer) > 1) {
          return layer.layer_title;
        } else {
          return layer.orig_title;
        }
      }
      if (this.getLayerCountByType(layer.layer_type) > 1) {
        return layer.layer_title;
      } else {
        return layer.orig_title;
      }
    };

    ViewController.prototype.destroyAllActiveLayers = function() {
      var i, layer, len, ref, subHandler;
      this.state.go('grower.data.view');
      ref = this.scope.activeLayers;
      for (i = 0, len = ref.length; i < len; i++) {
        layer = ref[i];
        subHandler = layer.layer_type + layer.layer_id;
        this.legacyHandler.destroySubHandler(subHandler, true);
        layer.handler = null;
      }
      this.scope.activeLayers = [];
      return this.destroyDialog();
    };

    ViewController.prototype.destroyActiveLayer = function(layer) {
      var index, subHandler;
      if (layer.layer_type === 'planting') {
        _.remove(this.scope.activeLayers, function(active_layer) {
          return active_layer === layer;
        });
        this.state.go('grower.data.view');
        return;
      }
      if (this.isAngularLayer(layer) && _.includes(this.scope.activeLayers, layer)) {
        _.remove(this.scope.activeLayers, function(active_layer) {
          return active_layer === layer;
        });
        return true;
      }
      subHandler = layer.layer_type + layer.layer_id;
      index = this.scope.activeLayers.indexOf(layer);
      if (!this.legacyHandler.activeSubHandlers[subHandler] && index === -1) {
        return false;
      }
      if (layer.layer_type === 'shapefile') {
        this.destroyDialog(layer.layer_id);
      }
      this.legacyHandler.destroySubHandler(subHandler, true);
      _.remove(this.scope.activeLayers, function(active_layer) {
        return active_layer === layer;
      });
      layer.handler = null;
      setTimeout((function(_this) {
        return function() {
          return _this.scope.$apply();
        };
      })(this), 0);
      return true;
    };

    ViewController.prototype.handleRowClick = function(layer, e) {
      var destroyLayer;
      if (this.scope.bulkDeleting) {
        if (layer.can_delete === true) {
          this.toggleBulkDeleteLayer(layer);
        }
        return;
      }
      if (this.destroyActiveLayer(layer)) {
        return;
      }
      destroyLayer = (function(_this) {
        return function() {
          layer.release();
          return _this.destroyActiveLayer(layer);
        };
      })(this);
      if (layer.layer_type === 'planting') {
        this.scope.activeLayers.push(layer);
        layer.release = this.transitions.onFinish({
          to: 'grower.data.view'
        }, destroyLayer);
        return this.viewFormLayer(layer);
      } else if (layer.layer_type === 'ears_rows_length') {
        return this.ngModal.openERLDialog(this.scope.selected_options.field.field_id, this.scope.selected_options.year, 'View', layer.layer_id).modalRef.result["catch"](_.noop);
      } else if (layer.layer_type === 'harvest_load') {
        return this.http.get("backend/grower/layers/harvest-load/" + layer.layer_id + "/load-layer").then((function(_this) {
          return function(harvestLoad) {
            return _this.ngModal.openHarvestLoadDialog(_this.scope.selected_options.field.field_id, _this.scope.selected_options.year, 'View', harvestLoad.data).modalRef.result["catch"](_.noop);
          };
        })(this));
      } else if (layer.layer_type === 'stand_count') {
        return this.http.post('backend/grower/layers/standcount/load-layer', {
          id: layer.id
        }).then((function(_this) {
          return function(standCountLoad) {
            return _this.ngModal.openStandCountDialog(_this.scope.selected_options.field.field_id, _this.scope.selected_options.year, 'View', standCountLoad.data).modalRef.result;
          };
        })(this));
      } else if (layer.layer_type === 'field_details') {
        this.scope.activeLayers.push(layer);
        layer.release = this.transitions.onFinish({
          to: 'grower.data.view'
        }, destroyLayer);
        return this.state.go('grower.data.view.field-details', {
          id: layer.id,
          year: this.scope.selected_options.year,
          editing: false
        });
      } else if (!this.isAngularLayer(layer)) {
        return this.viewLegacyLayer(layer);
      } else {
        return this.scope.activeLayers.push(layer);
      }
    };

    ViewController.prototype.irrigationDetails = function(layer) {
      return this.state.go('grower.data.view.irrigation-details', {
        layer_id: layer.id,
        year: this.scope.selected_options.year,
        field_id: this.scope.selected_options.field.field_id
      });
    };

    ViewController.prototype.isAngularLayer = function(layer) {
      var ref;
      return ref = layer != null ? layer.layer_type : void 0, indexOf.call(this.angularLayers, ref) >= 0;
    };

    ViewController.prototype.viewFormLayer = function(layer, edit) {
      var opts, params;
      if (edit == null) {
        edit = false;
      }
      opts = this.scope.selected_options;
      params = {
        id: layer.id,
        edit: edit ? 'edit' : null
      };
      if (layer.layer_type === 'planting') {
        params.is_ingredion_field = (opts.field.external_name != null) && opts.field.external_name === 'Ingredion' && opts.field.external_permission;
      }
      return this.state.go("grower.data.view." + layer.layer_type, params);
    };

    ViewController.prototype.viewLegacyLayer = function(layer) {
      var postParams, ref, save_url;
      this.scope.activeLayers.push(layer);
      save_url = this.legacyHandler.getLegacyFilePath(layer.layer_type);
      postParams = {
        fields_id: layer.fields_id,
        has_edit: false,
        id: layer.id,
        layer_id: layer.layer_id,
        year: layer.year,
        extra_data: (ref = layer.extra_data) != null ? ref : null
      };
      return layer.handler = this.legacyHandler.createViewDialog(layer.layer_type, save_url, false, false, layer, postParams);
    };

    ViewController.prototype.editLayer = function(layer) {
      if (layer.layer_type === 'management_zone') {
        return this.editManagementZoneLayer(layer);
      } else if (layer.layer_type === 'ears_rows_length') {
        return this.ngModal.openERLDialog(this.scope.selected_options.field.field_id, this.scope.selected_options.year, 'Edit', layer.layer_id).modalRef.result["catch"](_.noop);
      } else if (layer.layer_type === 'harvest_load') {
        return this.http.get("backend/grower/layers/harvest-load/" + layer.layer_id + "/load-layer").then((function(_this) {
          return function(harvestLoad) {
            return _this.ngModal.openHarvestLoadDialog(_this.scope.selected_options.field.field_id, _this.scope.selected_options.year, 'Edit', harvestLoad.data).modalRef.result["catch"](_.noop);
          };
        })(this));
      } else if (layer.layer_type === 'stand_count') {
        return this.http.post('backend/grower/layers/standcount/load-layer', {
          id: layer.id
        }).then((function(_this) {
          return function(standCountLoad) {
            return _this.ngModal.openStandCountDialog(_this.scope.selected_options.field.field_id, _this.scope.selected_options.year, 'Edit', standCountLoad.data).modalRef.result["catch"](_.noop);
          };
        })(this));
      } else if (layer.layer_type === 'planting') {
        return this.editFormLayer(layer);
      } else if (layer.layer_type === 'field_details') {
        return this.state.go('grower.data.view.field-details', {
          id: layer.id,
          year: this.scope.selected_options.year,
          editing: true
        });
      } else if (!this.isAngularLayer(layer)) {
        return this.editLegacyLayer(layer);
      }
    };

    ViewController.prototype.editFormLayer = function(layer) {
      return this.viewFormLayer(layer, true);
    };

    ViewController.prototype.editLegacyLayer = function(layer) {
      var postParams, ref;
      if (layer.layer_type === 'shapefile') {
        this.legacyHandler.getLegacyFilePath('ShapefileBinning');
      } else {
        this.legacyHandler.getLegacyFilePath(layer.layer_type);
      }
      postParams = {
        fields_id: layer.fields_id,
        has_edit: true,
        id: layer.id,
        layer_id: layer.layer_id,
        year: layer.year,
        extra_data: (ref = layer.extra_data) != null ? ref : null
      };
      return layer.handler = this.legacyHandler.createViewDialog(layer.orig_title, null, false, true, layer, postParams);
    };

    ViewController.prototype.editManagementZoneLayer = function(layer) {
      layer.year = this.scope.selected_options.year;
      layer.handler = null;
      return this.state.go('grower.data-edit-zone', {
        request: JSON.stringify(layer)
      });
    };

    ViewController.prototype.editRxLayer = function(id) {
      var options;
      options = new Storage();
      options.store('from_state', 'grower.data.view');
      window.RxStorage = options;
      return this.state.go('grower.planting-rx', {
        id: id
      });
    };

    ViewController.prototype.deleteLayer = function(layer) {
      var ref, ref1;
      if (layer.can_delete && ((layer.can_actually_delete == null) || layer.can_actually_delete)) {
        return this.legacyHandler.createDeleteDialog(layer);
      } else if ((ref = layer.extra_info) != null ? (ref1 = ref.crops) != null ? ref1.length : void 0 : void 0) {
        return this.launchRestrictedDeleteDialog(layer);
      }
    };

    ViewController.prototype.launchRestrictedDeleteDialog = function(layer) {
      var crop, dlg, has_fieldprint, has_planting_rx, k, message, newscope;
      message = 'You may not delete this Irrigation map. It is needed for your ';
      has_fieldprint = indexOf.call((function() {
        var ref, results;
        ref = layer.extra_info.mappings;
        results = [];
        for (k in ref) {
          crop = ref[k];
          results.push(crop.has_fieldprint);
        }
        return results;
      })(), true) >= 0;
      has_planting_rx = indexOf.call((function() {
        var ref, results;
        ref = layer.extra_info.mappings;
        results = [];
        for (k in ref) {
          crop = ref[k];
          results.push(crop.has_planting_rx);
        }
        return results;
      })(), true) >= 0;
      if (has_fieldprint && has_planting_rx) {
        message += "Fieldprint Analysis and Rx Plan.";
      } else if (has_fieldprint) {
        message += "Fieldprint Analysis.";
      } else if (has_planting_rx) {
        message += "Rx Plan.";
      }
      newscope = this.scope.$new();
      newscope.title = 'Delete - Irrigation Zone Layer';
      newscope.body = message;
      newscope.yesText = 'Ok';
      newscope.noText = 'Close';
      return dlg = this.modal.open({
        windowClass: 'sm_dialog',
        templateUrl: 'backend/core/confirm-dialog',
        controller: 'ConfirmDialogController',
        scope: newscope
      });
    };

    ViewController.prototype.callResizer = function() {
      return angular.element(this.window).trigger('resize');
    };

    ViewController.prototype.checkBulkDelete = function() {
      var i, layer, len, ref;
      ref = _.concat(this.scope.formsData, this.scope.mapsData);
      for (i = 0, len = ref.length; i < len; i++) {
        layer = ref[i];
        if (layer.can_delete === true) {
          this.scope.showBulkDelete = true;
          return;
        }
      }
    };

    ViewController.prototype.startBulkDelete = function() {
      this.destroyAllActiveLayers();
      return this.scope.bulkDeleting = true;
    };

    ViewController.prototype.toggleBulkDeleteLayer = function(layer) {
      var ref, ref1;
      if ((layer.can_actually_delete != null) && !layer.can_actually_delete && ((ref = layer.extra_info) != null ? (ref1 = ref.crops) != null ? ref1.length : void 0 : void 0)) {
        this.launchRestrictedDeleteDialog(layer);
        return;
      }
      if (indexOf.call(this.scope.bulkDeleteArray, layer) >= 0) {
        return _.remove(this.scope.bulkDeleteArray, (function(_this) {
          return function(del_layer) {
            return del_layer === layer;
          };
        })(this));
      } else {
        return this.scope.bulkDeleteArray.push(layer);
      }
    };

    ViewController.prototype.launchBulkDeleteDialog = function() {
      var dialog;
      dialog = this.modal.open({
        windowClass: 'sm_dialog',
        templateUrl: 'backend/grower/data/ng-bulk-delete',
        controller: 'Data.Controllers.BulkDeleteController',
        resolve: {
          'DeleteArray': (function(_this) {
            return function() {
              return _this.scope.bulkDeleteArray;
            };
          })(this)
        }
      });
      return dialog.result.then((function(_this) {
        return function(response) {
          return _this.endBulkDelete(true);
        };
      })(this));
    };

    ViewController.prototype.getCountByLayerType = function(type) {
      return this.scope.formData.filter((function(_this) {
        return function(layer) {
          return layer.layer_type === type;
        };
      })(this)).length;
    };

    ViewController.prototype.endBulkDelete = function(reload_data) {
      var ref;
      if (reload_data == null) {
        reload_data = false;
      }
      this.scope.bulkDeleteArray = [];
      this.scope.bulkDeleting = false;
      if (reload_data) {
        return this.getTableData(this.scope.selected_options.year, (ref = this.scope.selected_options.field) != null ? ref.field_id : void 0);
      }
    };

    ViewController.prototype.destroyDialog = function(layerId) {
      var layer_types, name, ref, results, subHandler, type;
      layer_types = ['File Conversion'];
      ref = this.legacyHandler.activeSubHandlers;
      results = [];
      for (name in ref) {
        subHandler = ref[name];
        if (subHandler instanceof DeleteDialog) {
          break;
        }

        /*
            Handle deleting the shapefile binning dialogs that are
            associated with layers that are being deselected
        
            The naming convention for these dialogs is
            "File Conversion"+id_of_related_layer
         */
        results.push((function() {
          var i, len, results1;
          results1 = [];
          for (i = 0, len = layer_types.length; i < len; i++) {
            type = layer_types[i];
            if (!(name.indexOf(type) !== -1 && name.indexOf(layerId) !== -1)) {
              continue;
            }
            subHandler.destroy();
            break;
          }
          return results1;
        })());
      }
      return results;
    };

    ViewController.prototype.layerUpdated = function(event, attributes) {
      this.showLoader();
      if ((attributes != null ? attributes.layer : void 0) != null) {
        this.destroyActiveLayer(attributes.layer);
      }
      return this.loadScopeData(this.data.getSidebarFields(), 'fields').then((function(_this) {
        return function() {
          var field, i, len, ref, ref1;
          if (_this.scope.selected_options.field != null) {
            ref = _this.scope.fields;
            for (i = 0, len = ref.length; i < len; i++) {
              field = ref[i];
              if (field.field_id === _this.scope.selected_options.field.field_id) {
                _this.scope.selected_options.field = field;
                break;
              }
            }
          }
          return _this.getTableData(_this.scope.selected_options.year, (ref1 = _this.scope.selected_options.field) != null ? ref1.field_id : void 0);
        };
      })(this));
    };

    return ViewController;

  })(Controller);

}).call(this);
